import { Module } from 'vuex';
import { RootState } from 'frontend/types';

export interface SavvyEmbed {
  js: string;
  html: string;
  flow: string;
  metadata: string;
}
interface SavvyPage {
  savvy_id: string | null;
  embed: SavvyEmbed | null;
}

interface SavvyLoggedOutHomepage {
  value: boolean;
}

export const savvyPage: Module<SavvyPage, RootState> = {
  namespaced: true,
  state: {
    savvy_id: null,
    embed: null,
  },
  getters: {
    savvyId: (state: SavvyPage): string | null => state.savvy_id,
    embed: (state): SavvyEmbed | null => state.embed,
  },
  mutations: {
    setValue(state: SavvyPage, value: SavvyPage): void {
      Object.assign(state, value);
    },
  },
};

export const savvyLoggedOutHomepage: Module<SavvyLoggedOutHomepage, RootState> = {
  namespaced: true,
  state: {
    value: false,
  },
  getters: {
    savvyEnabledLoggedOutHomepage: (state: SavvyLoggedOutHomepage): boolean => state.value,
  },
  mutations: {
    setValue(state: SavvyLoggedOutHomepage, value: SavvyLoggedOutHomepage): void {
      Object.assign(state, value);
    },
  },
};
